import { ApiResponse, fetcher } from './base-api';
import { SiteCategory } from './types/globals.type';
import { CategoryDto } from './types/pricing.type';

export const getPricingList = async (): Promise<ApiResponse<CategoryDto[]>> => {
  return fetcher<CategoryDto[]>('/pricing', {
    params: { category: SiteCategory.TRAINING },
  });
};

export const getPricingBestList = async (): Promise<
  ApiResponse<CategoryDto[]>
> => {
  return fetcher<CategoryDto[]>('/pricing/best', {
    params: { category: SiteCategory.TRAINING },
  });
};

export const getUnlimited2WeeksMaxDiscountAmount = async (): Promise<
  ApiResponse<number>
> => {
  return fetcher<number>('/pricing/unlimited-2weeks-max-discount-amount');
};
